import { create } from "zustand";

const defaultHeader = {
  theme: "light",
  bgClass: "default",
  variant: "primary",
  align: "left",
  isFluid: false,
  button: "cta", // profile, account, null
  buttonText: "Get started free", // profile, account, null
  reveal: true,
};

const defaultFooter = {
  theme: "dark",
  style: "style1", // style1, style2
};

// UI-only client state; use this instead of ad-hoc React state
export const useUiStore = create((set) => ({
  themeDark: false,
  showSidebarDashboard: true,
  applicationModalVisible: false,
  signInModalVisible: false,
  signUpModalVisible: false,
  videoModalVisible: false,
  visibleOffCanvas: false,
  header: defaultHeader,
  footer: defaultFooter,
  toggleTheme: () => set((state) => ({ themeDark: !state.themeDark })),
  toggleSidebarDashboard: () =>
    set((state) => ({ showSidebarDashboard: !state.showSidebarDashboard })),
  toggleVideoModal: () =>
    set((state) => ({ videoModalVisible: !state.videoModalVisible })),
  toggleApplicationModal: () =>
    set((state) => ({
      applicationModalVisible: !state.applicationModalVisible,
    })),
  toggleSignInModal: () =>
    set((state) => ({ signInModalVisible: !state.signInModalVisible })),
  toggleSignUpModal: () =>
    set((state) => ({ signUpModalVisible: !state.signUpModalVisible })),
  toggleOffCanvas: () =>
    set((state) => ({ visibleOffCanvas: !state.visibleOffCanvas })),
  closeOffCanvas: () => set({ visibleOffCanvas: false }),
  setHeader: (header) => set({ header }),
  setFooter: (footer) => set({ footer }),
  setThemeDark: (themeDark) => set({ themeDark }),
}));
